import { ObjectValueType } from "../../../../lib/types/utilityTypes/ObjectValueType";

/**
 * Тип предложения. Соответствует словарю offering_access_type
 * @prop COMMON: 1, // Общий
 * @prop PERSONAL: 3, // Индивидуальный
 */

export const OFFER_TYPES = {
  COMMON: 1, // Общий
  PERSONAL: 3, // Индивидуальный
} as const;

export type OFFER_TYPES = ObjectValueType<typeof OFFER_TYPES>;
